import cn from "classnames"
import { DeploymentTypeIconsGroup } from "../Icon"
import styles from "../Icon.module.scss"
import { DeploymentTypesProps } from "./DeploymentType.types"

export const DeploymentType = ({
  className,
  deploymentType,
  ...props
}: DeploymentTypesProps) => {
  const Icon =
    DeploymentTypeIconsGroup[deploymentType] || DeploymentTypeIconsGroup.unknown
  // A deployment type this UI has no icon for (e.g. one added by newer sensors)
  // renders without an icon instead of crashing the page
  if (!Icon) return null

  return (
    <Icon
      className={cn(styles[deploymentType], className)}
      data-tooltip-content={deploymentType}
      {...props}
    />
  )
}
